import React from 'react';
import { ToolComponentProps } from './types';
import { ChevronRight, ChevronDown } from 'lucide-react';

export const SearchTool: React.FC<ToolComponentProps> = ({
  input,
  output,
  isError,
  isExpanded,
  onToggle
}) => {
  const pattern = input?.pattern || '';
  const path = input?.path || '';
  const fileType = input?.file_type || '';
  const hasOutput = output !== undefined && output !== null;

  // Build search description
  let searchDesc = `Search: ${pattern}`;
  if (path) searchDesc += ` in ${path}`;
  if (fileType) searchDesc += ` (*.${fileType})`;

  return (
    <div>
      <div
        className={`flex items-center gap-1 ${hasOutput ? 'cursor-pointer hover:bg-accent/30' : ''} rounded transition-colors`}
        onClick={hasOutput ? onToggle : undefined}
      >
        <span className="flex-1">{searchDesc}</span>
        <span className="text-muted-foreground inline-block w-3">
          {hasOutput && (isExpanded ? <ChevronDown className="h-3 w-3" /> : <ChevronRight className="h-3 w-3" />)}
        </span>
      </div>

      {isExpanded && hasOutput && (
        <div className={`mt-2 rounded ${isError ? 'bg-destructive/10 text-destructive' : 'bg-muted'} overflow-x-auto`}>
          <pre className="whitespace-pre p-2">
            {typeof output === 'string' ? output : JSON.stringify(output, null, 2)}
          </pre>
        </div>
      )}
    </div>
  );
};